import * as Yup from 'yup';

import { NO_LEADING_TRAILING_SPACES_VALIDATION } from '@/shared/consts';

export const SPEAKER_VALIDATION_SCHEMA = Yup.object().shape({
  fullname: NO_LEADING_TRAILING_SPACES_VALIDATION.required('Обязательное поле').max(
    200,
    'Превышено допустимое количество символов',
  ),
  bio: NO_LEADING_TRAILING_SPACES_VALIDATION.required('Обязательное поле').max(
    500,
    'Превышено допустимое количество символов',
  ),
  photo: Yup.object({
    filename: Yup.string().required(),
    signed_id: Yup.string(),
    url: Yup.string(),
  })
    .nullable()
    .test('required', 'Обязательное поле', (value) => value !== null),
});
